const OnboardingQuestions = [
  {
    question: "What's your primary motivation for purchasing a property?",
    options: [
      "First time home ownership",
      "Upgrading living space",
      "Investment opportunity",
      "Relocation (family, work, other reason)",
      "Just browsing",
    ],
    key: "motivation",
    name: "Motivation",
    type: "radio",
  },
  {
    question: "Select all the cities you're interested in.",
    key: "city",
    name: "City",
    type: "multi-select-dropdown",
  },
  {
    question: "What's your preferred property type?",
    options: [
      "Detached",
      "Semi-Detached",
      "Att/Row/Townhouse",
      "Condo Apartment",
      "Duplex",
      "Triplex",
      "Other",
    ],
    key: "propertyType",
    type: "multi-select",
    name: "Property Type",
  },
  {
    question: "What's your ideal number of bedrooms?",
    options: ["1", "2", "3", "4+"],
    key: "bedrooms",
    name: "Bedrooms",
    type: "radio",
  },
  {
    question: "What's your ideal number of bathrooms?",
    options: ["1", "2", "3", "4+"],
    key: "bathrooms",
    name: "Bathrooms",
    type: "radio",
  },
  {
    question: "What's your target price range?",
    key: "priceRange",
    name: "Price Range",
    type: "slider",
  },
  {
    question: "Rank the following in order of importance",
    options: [
      "Location/Neighborhood",
      "Property size",
      "Price",
      "School district",
      "Potential for appreciation",
      "Proximity to amenities",
    ],
    key: "ranking",
    type: "ranking",
    name: "Ranking",
  },
  {
    question: "Select the 3 most important amenities to you",
    options: [
      "Parks / Greenspace",
      "Shopping / Restaurants / Entertainment",
      "Recreational / Community Centers",
      "Healthcare",
      "Public Transit / Commuting ",
      "Waterfront",
      "Schools / Libraries",
      "Other",
    ],
    key: "topAmenities",
    type: "multi-select",
    name: "Top Amenities",
  },
  {
    question: "How soon are you looking to buy?",
    options: [
      "Immediately",
      "Within 3 months",
      "Within 6 months",
      "Within 1 year",
      "Just browsing",
    ],
    key: "buyTimeline",
    name: "Buy Timeline",
    type: "radio",
  },
];

export default OnboardingQuestions;
